// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const franchise: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="franchise Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [
    {
      id: 'city',
      title: <FormattedMessage id="city" />,
      type: 'item',
      icon: icons.city,
      url: '/apps/city',
      breadcrumbs: false
    },
    
  ]
};

export default franchise;
